import {Pipe, PipeTransform} from '@angular/core';
import {IdName} from '@core/src/public-api';
import {diaryEventPeriodicityTypeCodes} from '@shared/constants/diary.constants';
import {DiaryEventPeriodicity} from '@shared/models/diary.model';
import {DiaryService} from '@shared/services/diary.service';

@Pipe({
  name: 'frequencyString'
})
export class FrequencyStringPipe implements PipeTransform {

  constructor(
    private diaryService: DiaryService
  ) { }

  transform(periodicityType: IdName, periodicity: DiaryEventPeriodicity): string {
    if (!periodicityType) {
      return;
    }

    let frecuencyString: string;
    switch (periodicityType.code) {
      case diaryEventPeriodicityTypeCodes.CUSTOMIZED:
        frecuencyString = this.diaryService.weekDaysToString(periodicity?.weekDays);
        break;
      default:
        frecuencyString = periodicityType.name;
    }

    return frecuencyString;
  }
}
